module.exports = __webpack_public_path__ + "static/media/sdk.21d4b409.png";